import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Mirrors backend validate_password_strength in backend/utils/auth.py
export function getPasswordError(password) {
  if (!password || password.length < 8) return 'Password must be at least 8 characters long.';
  if (!/[A-Z]/.test(password)) return 'Password must contain an uppercase letter.';
  if (!/[a-z]/.test(password)) return 'Password must contain a lowercase letter.';
  if (!/[0-9]/.test(password)) return 'Password must contain a number.';
  if (![...password].some(char => '!@#$%^&*()_+-=[]{}|;:,.<>?'.includes(char))) {
    return 'Password must contain a special character.';
  }
  return null;
}
